var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPioneer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8037 33.9705L61.7225 17.5769L62.4231 18.2775L46.0282 37.1938L80 39.4178V40.5822L46.027 42.8037L62.4231 61.7238L61.7225 62.4244L42.8037 46.0282L40.5822 80H39.4178L37.1938 46.0282L18.2762 62.4231L17.5756 61.7225L33.9693 42.8049L0 40.5822V39.4178L33.9693 37.1925L17.5769 18.2775L18.2775 17.5769L37.1938 33.9705L39.4178 0H40.5822L42.8037 33.9705Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPioneer);
export default __webpack_public_path__ + "static/media/pioneer.93b2041a2505b660840e2201fd46199b.svg";
export { ForwardRef as ReactComponent };